<template>
  <hm-content title="促销列表">
    <div class="mb10">
      当前商户: <span class="primary">{{ storeName }}</span>
    </div>
    <div class="table-panel  flex flex-between">
      <div class="flex">
        <div class="mr10">
          <el-button type="primary" size="small" @click="addStore"
            >新增门店</el-button
          >
        </div>
        <div class="mr10">
           <el-button
          type="primary"
          size="small"
          class="mr10"
          @click="riskManagementSet"
          >申报风控设置</el-button
        >
        </div>

        <div class="mr10">
          <el-button type="primary" size="small" @click="batchChangeStatus"
            >批量启用/禁用</el-button
          >
        </div>
        <div class="flex flex-end item-center">
          <div @click="outputExcel" class="delete mr20 pointer">
            <span class="delete-icon hmicon icon-daochu"></span>
            导出模板
          </div>
          <div class="delete mr20 pointer open-file">
            <span class="delete-icon hmicon icon-daoru"></span>
            导入门店
            <input
              type="file"
              @change="importf"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.xlsx"
            />
          </div>
        </div>
      </div>
      <!-- <div>
        <el-switch
            v-model="enabledState"
            size="mini"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="yes"
            active-text="启用"
            inactive-text="禁用"
            inactive-value="no"
            @change="enabledShowShop()"
            >
          </el-switch>
          <div style="color:#999;" v-if="enabledState === 'yes'">禁用后该商户不再显示此门店</div>
          <div style="color:#999;" v-else>开启后该商户显示此门店</div>
      </div> -->
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.shopName"
          placeholder="输入门店名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="storeShopInfoList.records"
        @selection-change="getChecked"
        stripe
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptPrintShopName"
          label="门店打印名称"
        ></el-table-column>

        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="provinceName"
          label="所在省"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cityName"
          label="所在市"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="districtName"
          label="所在区"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市/区"
          prop="citys"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.districtName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopAddress"
          label="门店地址"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="导购数量"
          prop="employeeCount"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeCode"
          label="是否维护小票"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.ifTemplate === "yes" ? "已维护" : "未维护" }}
            </div>
          </template>
        </el-table-column>
         <el-table-column
          header-align="center"
          align="center"
          prop="switch"
          label="申报风控开关"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.switch">{{ scope.row.switch }}</span>
            <span class="gray" v-else>未开启</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopTypeText"
          label="是否品牌店"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.brandAttrConfigNum > 0">
              品牌店
            </div>
            <div v-else>
              普通店
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="启用状态"
          width="180"
        >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.enabledState"
            size="mini"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="yes"
            active-text="启用"
            inactive-text="禁用"
            inactive-value="no"
            @change="enabledStateChange(scope.row)"
            >
          </el-switch>
        </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="storeCode"
          label="小票规则模板"
             width="200"
        >
          <template slot-scope="scope">
           <el-select
                clearable
                class="mr10"
                size="small"
                filterable
                style="width: 150px"
                v-model="scope.row.sysTemplateId"
                placeholder="小票规则模板"
                @change="relativeTypeChange(scope.row)"
              >
              <el-option :label="v.templateName" :value="v.id" v-for="(v,i) in allSysReceiptOcr" :key="i"></el-option>
           </el-select>
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="ocrRule(scope.row)"
              >小票规则</el-button
            >
            <el-button size="small" type="text" @click="correlation(scope.row)"
              >关联品牌</el-button
            >
            <el-button size="small" type="text" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button size="small" type="text" @click="remove(scope.row)" v-if="!isBtn('merchantStoreDeleteBtn:true')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="storeShopInfoList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="编辑门店与供应商关联"
      width="50%"
      :close-on-click-modal="false"
      :visible.sync="dialogSubVisible1"
      @close="resetForm('ruleForm')"
    >
    <el-dialog
      width="50%"
      title="新增关联供货商"
      :visible.sync="dialogInnerVisible1"
      append-to-body>
      <el-form
        :model="newRuleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="是否品牌店" prop="shopType">
          
          <el-select
            style="width: 100px"
            size="small"
            class="auto-width-select"
            v-model="newRuleForm.shopType"
            placeholder="请选择品牌店类型"
          >
            <el-option v-for="(item, i) in shopTypeList" :label="item.itemText" :value="item.itemValue" :key="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联供货商：">
          
          <el-select
            clearable
            v-model="newRuleForm.supplierCodeList"
            placeholder="请选择供货商"
            size="small"
            filterable
            @change="getCheckedStore"
            multiple
          >
            <el-option
              label="全部供货商"
              :disabled="selectOther"
              value="all"
            ></el-option>
            <el-option
              :label="v.storeName"
              :value="v.storeCode"
              :disabled="selectAll"
              v-for="(v, i) in microShopStoreList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm1('ruleForm')"
            >新增</el-button
          >
          <el-button size="small" @click="resetForm1('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
      
    </el-dialog>
    <el-table
        stripe
        :data="newSupplierList"
        @selection-change="getChecked"
        ref="singleTable"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
      prop="storeType"
      label="关联类型"
      header-align="center"
          align="center">
      <template slot-scope="scope">
        <el-tag
          type="success"
          disable-transitions>{{scope.row.shopTypeText || scope.row.shopType === 'brand' ? '品牌':'正常'}}</el-tag>
      </template>
    </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeName"
          label="关联供应商"
        ></el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="removeStore(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    <div class="flex flex-center" style="margin-top: 100px;">
          <el-button type="primary" size="small" @click="deleteAll"
            >批量删除</el-button
          >
          <el-button type="primary" size="small" @click="ss"
            >新增</el-button
          >
          <el-button type="primary" size="small" @click="saveAll"
            >保存</el-button
          >
          <el-button size="small" @click="xx"
            >关闭</el-button
          >
        </div>
    </el-dialog>
    <el-dialog
      title="批量启用/禁用"
      width="25%"
      :close-on-click-modal="false"
      :visible.sync="dialogSubVisible"
      @close="resetForm('ruleForm')"
    >
    <div>
        <el-switch
            v-model="enabledState"
            size="mini"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="yes"
            active-text="开启"
            inactive-text="关闭"
            inactive-value="no"
            
            >
          </el-switch>
          <div style="color:#999;margin-top: 20px;" v-if="enabledState === 'yes'">禁用后该商户不再显示此门店</div>
          <div style="color:#999;margin-top: 20px;" v-else>开启后该商户显示此门店</div>
      </div>
    <div class="flex flex-center" style="margin-top: 100px;">
          <el-button type="primary" size="small" @click="changeBatch"
            >保存</el-button
          >
          <el-button size="small" @click="resetBatch"
            >关闭</el-button
          >
        </div>
    </el-dialog>
    <el-dialog
      :title="mode === 'add' ? '新增门店' : '编辑门店'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="门店名称" prop="shopName">
          <el-input
            size="small"
            placeholder="请输入门店名称"
            v-model="ruleForm.shopName"
          ></el-input>
        </el-form-item>
        <el-form-item class="is-required" label="省市区" prop="citys">
         <!-- <el-cascader
            :options="area"
            size="small"
            ref="citys"
            clearable
            placeholder="请选择省市区"
            v-model="ruleForm.citys"
            :props="props"
          ></el-cascader>-->
          <el-cascader
              v-if="dialogVisible"
              clearable
              class="mr10"
              ref="cascader"
              v-model="ruleForm.citys"
              :props="queryProps"
              :show-all-levels="true"
              :change-on-select="true"
              filterable
              size="small"
              placeholder="请选择省市区"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="门店地址" prop="shopAddress">
          <el-input
            size="small"
            placeholder="请输入门店地址"
            v-model="ruleForm.shopAddress"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否月结门店" prop="shopMonthlyStatementFlag">
          <el-radio-group v-model="ruleForm.shopMonthlyStatementFlag">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>


    <!-- 删除弹窗 -->
    <el-dialog
      custom-class="delete_dialog"
      :visible.sync="deleteDialogVisible"
      width="723px"
      min-height="468px"
      :before-close="deleteHandleClose">
      <div slot="title" style="border-bottom: 1px solid #DDDDDD; padding-bottom: 20px; display: flex;align-items: center;">
        <p class="delete_title" style="display: flex;">删除门店<span style="display: flex;align-items: center;"><img style="width: 14px; height: 14px; margin-right: 6px;" src="@/assets/delete.png">检测该门店中有{{peopleNum}}名员工</span></p>
      </div>
      
      <div class="delete_box">
         <el-table
          ref="multipleTable"
          :data="deleteTableData"
          tooltip-effect="dark"
          style="width: 100%"
          stripe
          border
          @selection-change="handleSelectionChange">
          >
           <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            label="注册名"
            width="120">
            <template slot-scope="scope">{{ scope.row.guiderName }}</template>
          </el-table-column>
          <el-table-column
            prop="guiderPhone"
            label="绑定电话"
            width="120">
          </el-table-column>
          <el-table-column
            prop="shopName"
            label="门店"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="storeName"
            label="商户"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>

        <div class="item_box">

          <el-form
            label-width="100px"
            :model="ruleFormShop"
            ref="ruleFormShop"
          >
            <el-form-item label="选择商户" prop="storeCode">
              <el-select
                :disabled="allMerchant.length === 0"
                style="width: 300px"
                size="small"
                clearable
                placeholder="请选择商户"
                v-model="ruleFormShop.storeCode"
                class="mr10"
                filterable
                remote
                :remote-method="remoteMethod"
                @change="queryShop"
              >
                <el-option
                  v-for="item in storeBasicList"
                  :key="item.storeCode"
                  :label="item.storeName"
                  :value="item.storeCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择门店" prop="shopId">
              <el-select
                class="mr10"
                size="small"
                style="width: 300px"
                filterable
                v-model="ruleFormShop.shopId"
                placeholder="请选择门店"
              >
                <el-option
                  :label="v.shopName"
                  :value="v.shopId"
                  v-for="(v, i) in shopList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>



          <!-- <div class="item">
            <div class="left_b">
              <span style="color:#FF0000;">*</span><p style="font-size: 14px; color: #222222;">选择商户</p>
            </div>
            <el-select v-model="value" placeholder="请选择" size="small">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <div class="left_b">
              <span style="color:#FF0000;">*</span><p style="font-size: 14px; color: #222222;">选择门店</p>
            </div>
            <el-select v-model="value" placeholder="请选择" size="small">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
          </div> -->
      </div>

      </div>

      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;align-items: center;">
        <el-button type="primary" @click="deleteChangeStores('ruleFormShop')" size="small">确定换店删除</el-button>
        <el-button @click="deleteHandleClose" size="small">取 消</el-button>
      </span>


    </el-dialog>
     <el-dialog
      title="申报风控设置"
      :visible.sync="dialogRiskManagement"
      :close-on-click-modal="false"
    >
      <el-form ref="riskManagement" label-width="200px" class="demo-ruleForm">
        <div v-for="(v, i) in riskManagementList" :key="i">
          <el-form-item class="mb10" :label="v.itemText" :prop="v.itemValue">
            <el-switch
              v-model="v.status"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="1"
              inactive-value="0"
            ></el-switch>
            <div>{{ v.description }}</div>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitRiskManagement()"
            >确定</el-button
          >
          <el-button size="small" @click="dialogRiskManagement = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>


  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import area from "@/utils/area";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    const patternCitys = function(rule, val, callback) {
      if (!this.ruleForm.citys.length) {
        return callback(new Error("请选择省市区"));
      }
      callback();
    }.bind(this);
    return {
      deleteRow: {},
      peopleNum: 0,
      ruleFormShop: {
        shopId: "",
        storeCode: "",
      },
      rulesShop: {
        shopId: {
          required: true,
          message: "请选择门店!",
          trigger: "change",
        },
        storeCode: {
          required: true,
          message: "请选择商户!",
          trigger: "change",
        },
      },
      shopList:[],
      allMerchant: [],
      storeBasicList: [],
      deleteTableData: [],
      multipleSelection: [],
      deleteTitle: `提示`,
      deleteDialogVisible: false,
      area,
      currentRow: {},
      dialogSubVisible1: false,
      dialogInnerVisible: false,
      dialogInnerVisible1: false,
      mode: "add",
      dialogVisible: false,
      dialogSubVisible: false,
      microShopStoreList: [],
      newSupplierList: [],
      checkedAll: [],
      selectOther: false,
      selectAll: false,
      enabledState: "yes",
      newShopType: "",
      ruleForm: {
        citys: [],
        shopName: "",
        shopAddress: "",
        storeCode: this.$route.query.storeCode,
        shopMonthlyStatementFlag: false,
        shopType: "",
        supplierCodeList: [],
      },
      newRuleForm: {
        shopType: "",
        supplierCodeList: [],
      },
      props: {
        value: "value",
        children: "children",
      },
      rules: {
        citys: {
          validator: patternCitys,
          trigger: "change",
        },
        shopAddress: {
          required: true,
          trriger: "blur",
          message: "请输入门店地址",
        },
        shopName: {
          required: true,
          trriger: "blur",
          message: "请输入门店名称",
        },
        shopMonthlyStatementFlag: {
          required: true,
          trigger: "change",
          message: "请选择门店是否月结",
        },
        shopType: {
          required: true,
          trriger: "blur",
          message: "请选择门店类型",
        },
        supplierCodeList: {
          required: false,
        },
      },
      searchCondition: {
        shopName: "",
      },
      currentPage: 1,
      pageSize: 10,
      storeName: "",
      allSysReceiptOcr: [],
      shopTypeList: [],
      checkedRow: [],
       riskManagementList: [],
      queryProps: {
        lazy: true,
        checkStrictly: false,
        multiple: false,
        value: "code",
        // multiple: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store.dispatch("queryRegionCode").then((res) => {
              res.result.forEach((v) => {
                // v.disabled = true;
                v.code = v.value;
                // v.leaf = Boolean(!v.isParent);
                // v.value = v.orgCode;
                // v.label = v.departName;
              });
              resolve(res.result);
            });
          } else {
            this.$store
              .dispatch("queryRegionCode", {
                value: data.value,
                level,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = v.level === "3" ? true : false;
                    v.code = v.value;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      dialogRiskManagement: false,
    };
  },
  computed: mapGetters(["storeShopInfoList"]),
  watch: {},
  created() {
    this.queryAllMerchant();
    // this.updateShop();
  },
  mounted() {
    this.storeName = localStorage.getItem("shName");
    this.queryList();
    this.queryShopBrandType();
    //this.queryAllsysReceiptOcr();
    this.queryAllStore();
  },
  methods: {
    
    deleteHandleClose() {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.deleteDialogVisible = false;
          // done();
           this.ruleFormShop = {
              shopId: "",
              storeCode: "",
            }
            this.multipleSelection = []
        })
        .catch(_ => {});
    },
    // 删除选中
    handleSelectionChange(val){
      console.log("selection:", val);
      this.multipleSelection = val;
    },
    getChecked(selection) {
      // this.checkedRowNew = selection.map((v) => v.shopId);
      console.log("this.selection:", selection);
      this.checkedAll = selection;
      this.checkedRow = selection.map((v) => v.shopId);
      this.checkedRowString = this.checkedRow.toString();
      // this.num = selection.length;
    },
    async queryAllMerchant() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.allMerchant = result;
    },
    // 选择门店  去掉
    // async updateShop() {
    //   this.$store.dispatch("queryStoreShopInfoLists", {
    //     pageSize: 999,
    //     pageNo: 1,
    //     storeCode: this.$route.query.storeCode,
    //   }).then((res) => {
    //     this.shopList = res.result.records;
    //   });
    // },
     async riskManagementSet() {
      if (this.checkedRow.length) {
        console.log("this.checkedRowString:", this.checkedRowString);
        const { code, result } = await this.$store.dispatch("riskMngList", {
          // storeCodes: this.checkedRowString,
           codes:this.checkedRowString,
           type: "shop"
        });
        if (code === "0") {
          this.dialogRiskManagement = true;
          this.riskManagementList = result;
          this.riskManagementList.forEach((v) => {
            v.status = v.status.toString();
          });
        }
      } else {
        this.$message({
          message: "请选择！",
          type: "warning",
        });
      }
    },
    async submitRiskManagement() {
      this.riskManagementList.forEach((v) => {
        // v.storeCodes = this.checkedRowString;
        v.shopIds = this.checkedRowString;
        v.storeCode = this.$route.query.storeCode
      });
      let prams = JSON.parse(JSON.stringify(this.riskManagementList));
      console.log("prams:", prams);
      const { code } = await this.$store.dispatch("riskMngSaveShopDictItem", prams);
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success",
        });
        this.queryList();
        this.dialogRiskManagement = false;
      }
    },
    async queryAllStore() {
      let params = {
        pageSize: 9999,
        pageNo: 1,
      };
      const { code, result } = await this.$store.dispatch(
        "querySupplierBasicList",
        params
      );
      this.microShopStoreList = result.records;
    },
    async queryShopBrandType() {
      const { result } = await this.$store.dispatch("queryShopBrandType");
      this.shopTypeList = result;
      this.ruleForm.shopType = this.shopTypeList[0].itemValue;
    },
    enabledShowShop() {
      this.$confirm(
        `确定要批量${this.enabledState == "yes" ? "启用" : "禁用"}门店吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then((e) => {
          console.log("e", e);
          this.$store
            .dispatch("batchEditEnabledState", {
              stateShopIds: this.checkedRow,
              enabledState: this.enabledState,
            })
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.queryList();
              }
            });
        })
        .catch(() => {
          if (this.enabledState == "yes") {
            this.enabledState = "no";
          } else {
            this.enabledState = "yes";
          }
        });
    },
    async removeStore(row) {
      console.log(row);
      this.$confirm("确定删除该关联?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var index;
        while ((index = this.newSupplierList.indexOf(row)) !== -1) {
          this.newSupplierList.splice(index, 1);
        }
        this.$nextTick(() => {
          this.$refs.singleTable.doLayout();
        });
        console.log(this.newSupplierList);
      });
    },
    async enabledStateChange(row) {
      console.log("row: ", row);
      let params = JSON.parse(JSON.stringify(row));

      const { code } = await this.$store.dispatch("editStoreShopInfo", params);
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success",
        });
        this.queryList();
      }
    },
    async relativeTypeChange(row) {
      const { code } = await this.$store.dispatch("addOcrRule", row);
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success",
        });
        this.queryList();
      }
    },
    async queryAllsysReceiptOcr() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
      };
      //   const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      //   Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "sysReceiptOcrTemplateList",
        params
      );
      if (code === "0") {
        const { records } = result;
        this.allSysReceiptOcr = records;
      }
    },
    ocrRule(row) {
      this.$router.push({
        name: "OcrRule",
        query: {
          storeCode: this.$route.query.storeCode,
          shopId: row.shopId,
        },
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        storeCode: this.$route.query.storeCode,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryStoreShopInfoList", params);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    batchChangeStatus() {
      this.dialogSubVisible = true;
    },
    resetBatch() {
      this.dialogSubVisible = false;
    },
    changeBatch() {
      this.$confirm(
        `确定要批量${this.enabledState == "yes" ? "启用" : "禁用"}门店吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then((e) => {
          console.log("e", e);
          this.$store
            .dispatch("batchEditEnabledState", {
              stateShopIds: this.checkedRow,
              enabledState: this.enabledState,
            })
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.queryList();
                this.dialogSubVisible = false;
              }
            });
        })
        .catch(() => {
          if (this.enabledState == "yes") {
            this.enabledState = "no";
          } else {
            this.enabledState = "yes";
          }
        });
    },
    isBtn(code) {
      return this.isShowBtn(code);
    },    
    addStore() {
      this.dialogVisible = true;
      this.mode = "add";
    },
    correlation(row) {
      this.currentRow = row;
      this.currentRow.storeType = "supplier";
      this.dialogSubVisible1 = true;
      this.$store.dispatch("detailsStoreShopInfo", row).then((res) => {
        if (res.code === "0") {
          for (let key in res.result) {
            this.ruleForm[key] = res.result[key];
          }
          if (!this.ruleForm.shopType) {
            this.ruleForm.shopType = this.shopTypeList[0].itemValue;
          }
          this.ruleForm.citys = [
            this.ruleForm.shopProvinceCode,
            this.ruleForm.shopCityCode,
            this.ruleForm.shopDistrictCode,
          ];
          this.newSupplierList = this.ruleForm.shopAttrConfigList
            ? this.ruleForm.shopAttrConfigList
            : [];
          //比对添加对应名称
          if (this.ruleForm.shopAttrConfigList) {
            this.ruleForm.shopAttrConfigList.map((item) => {
              if (item.supplierCode != "all") {
                let index = this.microShopStoreList.findIndex(
                  (items) => items.storeCode == item.supplierCode
                );
                if (index != -1) {
                  item.storeName = this.microShopStoreList[index].storeName;
                } else {
                  item.storeName = "全部";
                }
              } else {
                item.storeName = "全部";
              }
              return item;
            });
          }
        }
      });
    },
    //保存品牌店
    ss() {
      this.dialogInnerVisible1 = true;
    },
    xx() {
      this.dialogSubVisible1 = false;
    },
    async saveAll() {
      console.log(this.ruleForm);
      this.newSupplierList.map((item) => {
        item.attrValue = item.shopType;
        item.attrType = "shopType";
        item.supplierCode = item.supplierCode
          ? item.supplierCode
          : item.storeCode;
      });
      this.ruleForm.shopAttrConfigList = this.newSupplierList;
      const { code } = await this.$store.dispatch(
        "editStoreShopInfo",
        this.ruleForm
      );
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success",
        });
        setTimeout(() => {
          this.resetForm();
        }, 0);
        this.dialogSubVisible1 = false;
        this.queryList();
      }
    },
    edit(row) {
      this.currentRow = row;

      this.mode = "edit";
      row.storeType = "supplier";

      this.$store.dispatch("detailsStoreShopInfo", row).then((res) => {
        if (res.code === "0") {
          for (let key in res.result) {
            this.ruleForm[key] = res.result[key];
          }
          if (!this.ruleForm.shopType) {
            this.ruleForm.shopType = this.shopTypeList[0].itemValue;
          }
          this.ruleForm.citys = [
            this.ruleForm.shopProvinceCode,
            this.ruleForm.shopCityCode,
            this.ruleForm.shopDistrictCode,
          ];
          this.$nextTick(() => {
            this.dialogVisible = true;
          });
        }
      });
    },
    deleteAll() {
      if (this.newSupplierList == [] || this.newSupplierList.length <= 0) {
        this.$message({
          message: "当前关联列表为空，不可删除操作！",
          type: "warning",
        });
      } else if (this.checkedAll == [] || this.checkedAll.length <= 0) {
        this.$message({
          message: "请先勾选需删除的关联商！",
          type: "warning",
        });
      } else {
        this.$confirm("确定批量删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          console.log("当前勾选项-->", this.checkedAll);
          this.checkedAll.map((item) => {
            let index;
            while ((index = this.newSupplierList.indexOf(item)) !== -1) {
              this.newSupplierList.splice(index, 1);
            }
          });

          // this.newSupplierList = [];
        });
      }
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex((o) => o !== "all") > -1;
      this.selectAll = storeList.findIndex((o) => o === "all") > -1;
    },
    async submitForm1() {
      console.log(this.ruleForm, this.newRuleForm);
      this.newRuleForm.supplierCodeList.map((item) => {
        if (item !== "all") {
          let index = this.microShopStoreList.findIndex(
            (items) => items.storeCode === item
          );
          let newArr = this.microShopStoreList[index];
          newArr.shopType = this.newRuleForm.shopType;
          this.newSupplierList.push(newArr);
        } else {
          let newArr = {
            storeName: "全部",
            shopType: "",
          };
          this.newSupplierList.push(newArr);
        }
        let uniqueArray = this.uniqueByKey(
          this.newSupplierList,
          (item) => item.storeCode
        );
        this.newSupplierList = uniqueArray;
        console.log(this.newSupplierList);
      });
      this.dialogInnerVisible1 = false;
      this.newRuleForm = {
        shopType: "",
        supplierCodeList: [],
      };
    },
    async resetForm1() {
      this.dialogInnerVisible1 = false;
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        this.ruleForm.shopProvinceCode = this.ruleForm.citys[0];
        this.ruleForm.shopCityCode = this.ruleForm.citys[1];
        this.ruleForm.shopDistrictCode = this.ruleForm.citys[2];
        let params = this.ruleForm;
        console.log(params);
        const { code } = await this.$store.dispatch(
          this.mode === "add" ? "saveStoreShopInfo" : "editStoreShopInfo",
          params
        );
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          setTimeout(() => {
            this.resetForm();
          }, 0);
          this.dialogVisible = false;
          this.queryList();
        }
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {
        citys: [],
        shopName: "",
        shopAddress: "",
        storeCode: this.$route.query.storeCode,
        shopMonthlyStatementFlag: false,
      };
      this.dialogVisible = false;
    },
    // 删除
    async remove(row) {
      console.log(row);
      this.deleteRow = row;
      this.deleteTableData = [];
      const {code, result} = await this.$store.dispatch("queryGuiderAndShopNameList", {
        shopId: row.shopId,
        storeCode: this.$route.query.storeCode,
      });
      
      if(code == 0 && !result.length){
        const res = await this.$confirm("检测到该门店中没有导购，是否删除本行数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        if (res === "confirm") {
          this.deleteFunc();
        }
      }
      // 有门店的时候
      if(code == 0 && result.length){
        this.deleteDialogVisible = true;
        this.peopleNum = result.length;
        this.deleteTableData = result;
        // this.updateShop();
      }
    },
    // 删除操作
    async deleteFunc(){
      // console.log('为什么不触发')
      const { code } = await this.$store.dispatch("delStoreShopInfo", this.deleteRow);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.queryList();
          this.deleteDialogVisible = false;
          this.ruleFormShop = { storeCode: "", shopId: "" };
          this.multipleSelection = []
        }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.storeBasicList = this.allMerchant.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicList = [];
      }
    },
    async queryShop(storeCode) {
      this.$store.dispatch("queryStoreShopInfoListIi", {
        pageSize: 999,
        pageNo: 1,
        storeCode: storeCode,
      }).then((res) => {
        this.shopList = res.result.records;
      });
    },
    // 确定换店删除
    deleteChangeStores(){
      // console.log(this.ruleFormShop.storeCode);
      // console.log(this.ruleFormShop.shopId);
      let that = this;
      let arss = [];
      let presentShopId = this.deleteTableData[0].shopId
      if(that.multipleSelection.length) {
          that.multipleSelection.forEach((item) => {
          arss.push(item.guiderId);
        });
          if(that.ruleFormShop.storeCode && that.ruleFormShop.shopId){
          that.$store.dispatch("operateBatch", {
            shopId:that.ruleFormShop.shopId,
            storeCode:that.ruleFormShop.storeCode,
            addSwitchShopRecord: 'yes',
            guiderIdList: arss,
            presentShopId
          }).then(res => {
            console.log(res);
            if(res.code == '0'){
              console.log('换店删除成功')
              that.deleteFunc(); // 删除成功
            }
            console.log('确定换店删除')
          })
        }else {
          that.$message({
            message: "请选择商户和门店",
            type: "warning",
          });
        }
      }else {
         that.$store.dispatch("operateBatch", {
            shopId:null,
            storeCode:null,
            addSwitchShopRecord: 'yes',
            guiderIdList: null,
            presentShopId
          }).then(res => {
              that.deleteFunc(); // 删除成功
          })
      
      } 
    },
    uniqueByKey(arr, key) {
      const seen = {};
      return arr.filter((item) => {
        const k = key(item);
        return seen.hasOwnProperty(k) ? false : (seen[k] = true);
      });
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["门店名", "省", "市", "区/县", "详细地址"];
        const data = [];
        exportJsonToExcel(tHeader, data, "导入门店模板");
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];

        result.forEach((v) => {
          formatResult.push({
            shopName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
            shopProvinceName: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
            shopCityName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
            shopDistrictName: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
            shopAddress: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
            storeCode: that.$route.query.storeCode,
          });
        });
        that.$store
          .dispatch("importRedpackageStoreList", formatResult)
          .then((res) => {
            const { code } = res;
            if (code === "0") {
              that.$message({
                message: "导入成功！",
                type: "success",
              });
              that.queryList();
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
  },
};
</script>
<style lang="scss" scoped>
 .delete_dialog {
  border-radius: 8px;
 }
.delete_title {
  font-size: 18px;
  color: #222222;
  span {
    font-size: 14px;
    color: #FF0000;
    line-height: 16px;
    padding-left: 20px;
  }
}
.delete_box {
  .step {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    li {
      line-height: 50px;
    }
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .item_box {
    margin-top: 40px;
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .left_b {
        display: flex;
        align-items: center;
        margin-right: 20px;
      }
    }
  }


}



</style>
